export default __webpack_public_path__ + "static/media/arrow-up.3e7abd66.svg";